import { DragDropContext, Droppable } from '@hello-pangea/dnd';
import { Box } from '@mui/material';
import React from 'react';

interface IDragAndDropListProps {
  prefix?: string;
  dataTest: string;
  children: React.ReactNode;
  onDragEnd(sourceIndex: number, destinationIndex: number): void;
}
export const DragAndDropList: React.FC<IDragAndDropListProps> = ({ dataTest, prefix, children, onDragEnd }) => {
  /* istanbul ignore next */
  const droppableId = prefix ? `${prefix}_droppable_container` : 'droppable_container';
  return (
    <DragDropContext
      onDragEnd={(result) => {
        const { destination, source } = result;
        onDragEnd(source?.index, destination?.index);
      }}
    >
      <Droppable droppableId={droppableId}>
        {(provided) => (
          <Box
            {...provided.droppableProps}
            ref={provided.innerRef}
            data-test={dataTest}
            sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
          >
            {children}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </DragDropContext>
  );
};
